export default function (type, enable, maxCurrent, maxTweets, remain) {
  // TODO:スタータープラン廃止後は判定対象から除外するのは ruby プランだけになる
  const exclusions = ["ruby", "devel", "silver", "gold", "platinum", "diamond"];

  if (!exclusions.includes(type)) {
    // 増量オプション自動適用設定の更新を予約しているか判定
    // ただし、増量オプションデータプール件数が 0 の場合は常に非予約中（false）を返す
    if (enable) {
      if (maxCurrent === maxTweets + remain) {
        return false;
      }
      return true;
    }
    else {
      if (maxCurrent === maxTweets) {
        return false;
      }
      return true;
    }
  }
}
